type Rect = { top: number; right: number; bottom: number; left: number };

export function positionDentalPicker({ anchor, boundary, viewport, width, height }: {
  anchor: Rect;
  boundary: Rect;
  viewport: Rect;
  width: number;
  height: number;
}) {
  const topEdge = Math.max(boundary.top, viewport.top) + 8;
  const bottomEdge = Math.min(boundary.bottom, viewport.bottom) - 8;
  const leftEdge = Math.max(boundary.left, viewport.left) + 8;
  const rightEdge = Math.min(boundary.right, viewport.right) - 8;
  if (bottomEdge <= topEdge || rightEdge <= leftEdge
    || anchor.bottom <= topEdge || anchor.top >= bottomEdge
    || anchor.right <= leftEdge || anchor.left >= rightEdge) return null;

  const panelWidth = Math.min(width, rightEdge - leftEdge);
  const desiredHeight = Math.min(height, 360);
  const below = Math.max(0, bottomEdge - anchor.bottom - 8);
  const above = Math.max(0, anchor.top - topEdge - 8);
  const placement = below >= desiredHeight || below >= above ? "bottom" : "top";
  const maxHeight = Math.min(desiredHeight, placement === "bottom" ? below : above);
  if (maxHeight <= 0) return null;

  return {
    placement,
    panelWidth,
    maxHeight,
    left: Math.max(leftEdge, Math.min(anchor.left, rightEdge - panelWidth)),
    top: placement === "bottom" ? anchor.bottom + 8 : anchor.top - 8 - maxHeight,
  };
}
